<template>
  <div class="column avg-star-rating">
    <!-- Card Head Begins -->
    <div class="avg-rating">
      <span class="card-text">Average star rating</span>
      <span class="is-pulled-right">
        <i class="fas fa-star" :class="getRatingClass(Math.round(averageRating))"></i> <span :class="getRatingClass(Math.round(averageRating))">{{ !isNaN(averageRating) ? averageRating : 0 }}</span>
      </span>
    </div> <!-- Card Head Ends -->
    <hr>
    <!-- Percentage Ratings Begins -->
    <div class="avg-rating-body" v-for="rating in starRatings">
      <span class="card-text is-full"><animated-number :value="getPercentageRating(rating.rating)" :duration="500" :formatValue="formatStats" round="1"></animated-number>%</span>
      <div class="columns is-marginless is-flex-mobile">
        <span class="rating-star"><rating :stars="rating.stars"></rating></span>
        <span class="reviews-text"><animated-number :value="rating.rating" :duration="500" :formatValue="formatStats" round="1"></animated-number> {{rating.rating > 1 ? 'Reviews' : 'Review'}}</span>
      </div>
      <div>
        <progress class="progress custom-progress" :class="getRatingClass(rating.stars)" :value="getPercentageRating(rating.rating)" max="100">{{getPercentageRating(rating.rating)}}%</progress>
      </div>
    </div> <!-- Percentage Ratings Ends -->

    <!-- Total reviews -->
    <div class="columns total-reviews" v-if="showTotal">
      <div class="column">
        Total <span>{{totalRatings|formatDigit}}</span> reviews
      </div>
    </div>
    <!-- Total reviews -->
  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,valid-jsdoc */
  import _ from 'lodash/math'
  import numWords from 'num-words'
  import Rating from '@/components/Rating'
  import AnimatedNumber from 'animated-number-vue'
  import {misc} from '@/mixins'

  export default {
    name: 'AverageRatingCard',
    components: {
      Rating,
      AnimatedNumber
    },
    mixins: [misc],
    props: {
      starRatings: {
        type: Array,
        required: true
      },
      showTotal: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      /**
       * Total ratings given to reviews including all stars
       * @return {Number}
       */
      totalRatings () {
        return _.sumBy(this.starRatings, 'rating')
      },
      /**
       * Average rating of all the ratings given
       * Formula rating = {starRatingFromApi} * {starRating} (4.5 * 3 for 3 Star Rating)
       * @return {string}
       */
      averageRating () {
        let temp = 5
        let sum = _.sumBy(this.starRatings, function (val) {
          let total = val.rating * temp
          --temp
          return total
        })
        return (sum / this.totalRatings).toFixed(1)
      }
    },
    methods: {
      /**
       * Get percentage rating to all of progress bar
       * @return {Number}
       */
      getPercentageRating (rating) {
        return this.calcProgressPercent(rating, this.totalRatings)
      },
      /**
       * Get related color class as per rating
       * {is-one, is-two, is-three, is-four, is-five}
       * @return {String}
       */
      getRatingClass (rating) {
        return 'is-' + numWords(rating)
      },
      /**
       * Format the float numbers upto two digits after decimal
       * @param {string} value Value of stat
       * @param {integer} digits Digits upto which rounding has to be done
       * @return {string|integer}
       */
      formatStats (value, digits = 2) {
        return !Number.isInteger(value) ? `${Number(value).toFixed(digits)}` : value
      }
    },
    filters: {
      /**
       * Format the integer by separator (comma (,)) after three digits (e.g 1,530)
       * @param val
       * @return {string}
       */
      formatDigit (val) {
        return val.toLocaleString()
      }
    }
  }
</script>

<!-- Local Scoped CSS Begins -->
<style scoped>
  .column {
    border: solid 1px rgba(88, 89, 91, 0.32);
    margin-left: 1%;
  }
  .column hr{
    margin: 0.5rem 0;
  }

  .avg-rating {
    font-size: 12px;
    font-weight: bold;
    line-height: 27px;
  }
  .avg-rating-body {
    margin-bottom: 2%;
  }

  .rating-star {
    font-size: 7px;
  }
  .card-text {
    font-size: 11px;
    font-weight: bold;
  }
  .reviews-text {
    font-size: 11px
  }
  .rating-star {
    width: 50%
  }
  .reviews-text {
    width: 50%;
    text-align: right;
  }
  .total-reviews {
    font-size: 12px;
    color: #58595b;
  }
  .total-reviews .column {
    border: none;
    text-align: end;
    padding: 12px 0 12px;
  }
  .total-reviews .column span {
    font-size: 14px;
    font-weight: bold;
  }
  .rating-star >>>img {
    height: 11px;
  }
</style>
<!-- Local Scoped CSS Ends -->
<!-- Global Scoped CSS Begins -->
<style>
  .rating-star ul li:first-child {
    margin-left: 0px !important;
  }
</style>
<!-- Global Scoped CSS Ends -->



// WEBPACK FOOTER //
// src/components/AverageRatingCard.vue